import styled from 'styled-components'

/** Gradient trash icon used in delete confirmation dialogs (Figma Layer_1). */
export const DELETE_CONFIRM_ICON_SRC = '/assets/icons/delete.svg'

const DeleteConfirmIcon = styled.img.attrs({
  src: DELETE_CONFIRM_ICON_SRC,
  alt: '',
})`
  width: 50px;
  height: 50px;
  display: block;
  flex-shrink: 0;
`

export default DeleteConfirmIcon
